module.exports = __webpack_public_path__ + "img/Yep_Navmii.420287bf.png";